import axios from 'axios';
import config from '../config.json';

const instance = axios.create();

instance.defaults.headers.common['x-api-key'] =
	config[process.env.REACT_APP_STAGE].key;

export default instance;
